export default "__VITE_ASSET__2qHIKvnm__"